export default __webpack_public_path__ + "static/media/hipster-avatar.5976f435.png";